import { memo } from 'react';

import useAnalytics from 'src/hooks/useAnalytics';

const AnalyticsCollector = () => {
  useAnalytics();

  return null;
};

export default memo(AnalyticsCollector);
